import AddressPicker from '@/components/pickers/AddressPicker.vue'
import w3w from '@/components/fields/w3w.vue'
export default {
  computed: {
    fields() {
      let helpText = [
        // normal:
        {
          notes: 'Any extra information people might need in order find this location (optional). For example: Room number 123 in the North Wing'
        },
        // online:
        {
          notes: 'Information to help them connect online'
        }
      ]

      let isOnline = this.location.is_virtual
      let index = 0
      if (isOnline) { index = 1 }
      let fields = [
        {
          id: 'name',
          attrs: {
            label: 'Location name',
            persistentHint: true,
            filled: true,
            hint: 'The place of interest name for this location. e.g.: Jane Smith Biokinetics Randburg or The Wellness Center',
            required: true
          },
          containerAttrs: { xs12: true, mt: 5 }
        },
        {
          id: 'is_virtual',
          attrs: {
            label: 'This location is online',
            persistentHint: true,
            filled: true,
            hint: 'Tick this for virtual location - e.g.: online only via Zoom calls'
          },
          component: 'vcheckbox',
          containerAttrs: { xs12: true, mt: 5 }
        }
      ]

      let normalFields = [
        {
          id: 'place',
          attrs: {
            label: 'Search for your address',
            hint: 'Physical address',
            apiKey: 'AIzaSyDBLqBJhup-u2afKcqqonWzGC-vv_7YpnY'
          },
          containerAttrs: { xs12: true },
          component: AddressPicker
        },
        {
          id: 'address',
          attrs: {
            label: 'Address',
            persistentHint: true,
            hint: 'Physical address',
            required: true
          },
          containerAttrs: { xs12: true }
        },
        {
          id: 'latitude',
          attrs: {
            label: 'Latitude',
            required: true
          },
          containerAttrs: { xs12: true, sm6: true }
        },
        {
          id: 'longitude',
          attrs: {
            label: 'Longitude',
            required: true
          },
          containerAttrs: { xs12: true, sm6: true }
        },
        {
          id: 'preferred_map_url',
          attrs: {
            type: 'url',
            label: 'Preferred map Link',
            prependIcon: 'mdi-map-marker',
            persistentHint: true,
            placeholder: 'https://maps.app.goo.gl/sZkpNRU5yksmfdFy6',
            hint: 'Your preferred map link to share. Tip: Find your location in Google Maps -> share -> use the generated link. Leave blank for AppointmentGuru to autogenerate a link for you'
          },
        },
        {
          id: 'three_words',
          attrs: {
            latitude: this.location.latitude,
            longitude: this.location.longitude,
          },
          component: w3w
        }
      ]
      let virtualFields = [
        {
          id: 'url',
          attrs: {
            label: 'URL',
            persistentHint: true,
            placeholder: 'https://example.com',
            hint: 'If you have a meeting room URL which you always use for online meetings, use it here and we will automatically set it on your appointments. Note: If you have the Zoom integration, this URL will be generated for you automatically'
          },
          containerAttrs: { xs12: true }
        }
      ]
      if (isOnline === true) {
        fields = fields.concat(virtualFields)
      } else {
        fields = fields.concat(normalFields)
      }
      let sharedFields = [
        {
          id: 'phone',
          attrs: {
            label: 'Contact number',
            type: 'tel',
            placeholder: '+27821111111',
            prependIcon: 'mdi-phone'
          },
          containerAttrs: { xs12: true }
        },
        {
          id: 'email',
          attrs: {
            label: 'Contact email address',
            type: 'email',
            placeholder: 'joe@example.com',
            prependIcon: 'mdi-email'
          },
          containerAttrs: { xs12: true }
        },
        {
          id: 'website',
          attrs: {
            label: 'Website',
            type: 'url',
            placeholder: 'https://example.com',
            prependIcon: 'mdi-web'
          },
          containerAttrs: { xs12: true }
        },
        {
          id: 'notes',
          component: 'vtextarea',
          attrs: {
            label: 'Extra information',
            persistentHint: true,
            filled: true,
            hint: helpText[index].notes
          },
          containerAttrs: { xs12: true }
        },
      ]
      fields = fields.concat(sharedFields)
      return fields
    }
  }
}
